import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e37b67e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Não é aceito cartão de débito, somente crédito.", -1))
const _hoisted_3 = { class: "inputs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_with_balance = _resolveComponent("header-with-balance")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Adicionar cartão",
            "has-go-back": false,
            "has-go-back-modal": true
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, { class: "info-card-debit" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, { icon: _ctx.informationCircle }, null, 8, ["icon"]),
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Número do cartão")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.numberCard,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.numberCard) = $event)),
                                type: "tel",
                                autocomplete: "cc-number"
                              }, null, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.numberCard) = $event)),
                                style: {"display":"none"}
                              }, null, 512), [
                                [_vModelText, _ctx.numberCard],
                                [_directive_mask, '#### #### #### ####']
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Validade")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.validate,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.validate) = $event)),
                                type: "tel",
                                placeholder: "Validade",
                                autocomplete: "cc-exp"
                              }, null, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.validate) = $event)),
                                style: {"display":"none"}
                              }, null, 512), [
                                [_vModelText, _ctx.validate],
                                [_directive_mask, '##/##']
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("CVV")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.cvv,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cvv) = $event)),
                                type: "tel",
                                maxlength: "3",
                                autocomplete: "cc-csc"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Nome do titular")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.name,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.name) = $event)),
                                class: "holder-name",
                                type: "text",
                                autocomplete: "cc-name"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("CPF")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.cpf,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.cpf) = $event)),
                                type: "tel",
                                maxlength: "14",
                                autocomplete: "off"
                              }, null, 8, ["modelValue"]),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.cpf) = $event)),
                                style: {"display":"none"}
                              }, null, 512), [
                                [_vModelText, _ctx.cpf],
                                [_directive_mask, '###.###.###-##']
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, { class: "ion-no-padding" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Apelido para o cartão")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                modelValue: _ctx.nickname,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nickname) = $event)),
                                type: "text",
                                enterkeyhint: "done",
                                autocomplete: "off",
                                onKeyup: _withKeys(_ctx.saveCardDataBase, ["enter"])
                              }, null, 8, ["modelValue", "onKeyup"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, {
                name: "Confirmar",
                onClick: _ctx.saveCardDataBase
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}